'use client'

import type {ReactNode} from 'react'
import {useVisualViewport} from './viewport'
import styles from './EditorFlow.module.css'

/** One scroll owner for header, body and actions; native input focus owns scrolling. */
export function EditorFlow({children, header}: {children: ReactNode; header?: ReactNode}) {
    useVisualViewport()
    return <div className={styles.flow} data-editor-scroll="">
        {header ? <div className={styles.header} data-editor-header="">{header}</div> : null}
        {children}
    </div>
}
